export const company_info = {
    nom : 'Delivo',
    mf : '1698802J',
    adresse : '9 rue Beyya el Ayari , El manar 1',
    phone : '98 360 460 | 71 870 528'
}